import {observer} from 'mobx-react-lite';
import React from 'react';

import {
  Side,
  SubNavigationBarItem,
  SubNavItem,
} from './Item/SubNavigationBarItem';
import {
  NavigationGroup,
  StyledSubNavigationBar,
} from './SubNavigationBar.styles';

export type Props<T extends object> = {
  activeTabItem?: SubNavItem<T>;
  className?: string;
  items: SubNavItem<T>[];
  ref?: React.Ref<HTMLElement>;
  onChange: (arg0: SubNavItem<T>) => void;
};

const USubNavigationBar = <T extends object = SubNavItem>({
  items,
  className,
  onChange,
  activeTabItem,
}: Props<T>): React.ReactElement => (
  <StyledSubNavigationBar className={className}>
    <NavigationGroup>
      {items
        .filter(({side = Side.Left}) => side === Side.Left)
        .map((item, index) => (
          <SubNavigationBarItem<T>
            key={item.id || index}
            active={activeTabItem?.id === item.id}
            item={item}
            onClick={onChange}
          />
        ))}
    </NavigationGroup>
    <NavigationGroup>
      {items
        .filter(({side = Side.Left}) => side === Side.Right)
        .map((item, index) => (
          <SubNavigationBarItem<T>
            key={item.id || index}
            active={activeTabItem?.id === item.id}
            item={item}
            onClick={onChange}
          />
        ))}
    </NavigationGroup>
  </StyledSubNavigationBar>
);

export const SubNavigationBar = observer(USubNavigationBar);
